import expireCreditAppDeals from './expireCreditAppDeals.js';
import expireCreditVerification from './expireCreditVerification.js';
import buildDefaultPaymentsInfo from './buildDefaultPaymentsInfo.js';
import { fullPaymentsInfoKeys } from '../constants/paymentsInfoKeys.js';
function validatePaymentsInfo(paymentsInfo, myWalletConfigs, customWalletDefaults) {
  const validatedPaymentsInfo = {
    ...paymentsInfo
  };

  // delete old irrelevant keys from payments info
  // NOTE: any new keys should be added to defaultState if they want to persist
  Object.keys(validatedPaymentsInfo).forEach(key => {
    // WALLET MANAGER TODO: Do we still need timestamp with local storage data being gone?
    // need to keep timestamp for local storage expiration
    if (!fullPaymentsInfoKeys.includes(key) && key !== 'timeStamp') {
      delete validatedPaymentsInfo[key];
    }
  });

  // if payment info is present but some of the required values are null, set them to default values
  const {
    creditType,
    downPayment,
    downPaymentPercent,
    loanTerm,
    interestRate = {}
  } = validatedPaymentsInfo;
  const hasRequiredValues = creditType == null || loanTerm == null || downPayment == null && downPaymentPercent == null;
  const hasInterestRates = Object.keys(interestRate).length === 0;
  const defaultPaymentsInfo = buildDefaultPaymentsInfo(myWalletConfigs, customWalletDefaults);
  if (hasRequiredValues || hasInterestRates) {
    Object.keys(validatedPaymentsInfo).forEach(key => {
      if (validatedPaymentsInfo[key] == null || Object.keys(validatedPaymentsInfo[key]).length === 0) {
        // Set default value if missing
        validatedPaymentsInfo[key] = defaultPaymentsInfo[key];
      }
    });
  }
  expireCreditAppDeals(validatedPaymentsInfo);
  expireCreditVerification(validatedPaymentsInfo);
  return validatedPaymentsInfo;
}
export { validatePaymentsInfo as default };
